// import Inbox from './components/Inbox'
const Index = () => import( /* webpackChunkName: "home" */ './index.vue');
const Student = () => import( /* webpackChunkName: "home" */ '@/modules/TeacherModules/Students/Profile.vue');
const ClassRoom = () => import( /* webpackChunkName: "home" */ '@/modules/TeacherModules/Home/components/AddStudentToClass.vue');
const Attendance = () => import( /* webpackChunkName: "home" */ '@/modules/TeacherModules/Attendance/Create.vue');
const Report = () => import( /* webpackChunkName: "home" */ '@/modules/TeacherModules/Attendance/Report.vue');
// import Attendance from '@/modules/TeacherModules/Attendance/Create.vue'
// let routes = [];
// routes = routes.concat(CategoryRoutes);



// routes = routes.concat([{
//   path: ':id/profile',
//   name: 'student-profile',
//   component: Student,
// }, ]);

export default [{
  path: '/',
  name: 'thome',
  component: Index,
  title: 'Home',
  // children: routes,
  // redirect: { name: 'inbox-view' },
}, {
  path: 's/profile',
  name: 'student-profile',
  component: Student,
  props: true,
  title: 'Student',
}, {
  path: 'room',
  name: 'add-student-to-class-room',
  component: ClassRoom,
  props: true,
  title: 'Class Room',
}, {
  path: 'attendance',
  name: 'class-room-attendance',
  component: Attendance,
  props: true,
  title: 'Class Room Attendance',
}, {
  path: 'report',
  name: 'class-room-report',
  component: Report,
  props: true,
  title: 'Report',
}]